import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import { DefaultQueryParams, isMobile, parseQuery } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { gameLiveConnection, registerApis } from '../../services';
import { gameName } from '../../enums/gameConfigsAndUrls';
import { soundService } from '../../services/SoundService';
import { resizeGameHandler } from '../../helpers/resizeGame';
import { TURBO_GAME_ID } from '../../enums/constants';
import { liveConnection } from '../liveConnection';

export const init = () => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const isTurbo = +gameId === TURBO_GAME_ID;

  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
  } else {
    resizeGameHandler();
    window.addEventListener('resize', resizeGameHandler);
    document.documentElement.classList.add('is-web');
  }

  const platformIntegrationConfig = {
    sectionCount: 1,
    bogLineGameTypeData: {
      isUsedPlatformIntegrationLogic: true,
      isUsedStakeUpdateLogic: true,
    },
    isUsedBogLineComponents: false,
    initPlatformMessageConfigs: true,
    isAllSectionWithCashOutButton: false,
    isUsedInputValidationFunctionality: false,
    isUsedRoundStartAndFinishedLogicAfterCashOut: false,
  };

  const updatedDefaultSettings = isTurbo
    ? {
        isMusicOn: false,
        isSoundOn: false,
      }
    : {};

  userSettingsStore.localStorageAndUserSettingsInit({
    gameName,
    soundService,
    updatedDefaultSettings,
    liveConnection,
    gameLiveConnection,
  });
  registerApis();
  gameConfigStore.initGameConfigs(platformIntegrationConfig);
};
